import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../environments/environment";
import {Page, PointEmailRequest, ProcessPointRound, SrmPointJobDto,} from "../../generated-model/model";
import {Observable} from "rxjs";
import {IgnoreNullHttpParams} from "../shared/commons/Ignore-null-http-params";

@Injectable({providedIn: "root"})
export class SrnProcessPointResource {
  http = inject(HttpClient);

  public getCurrentRound(): Observable<ProcessPointRound> {
    return this.http.get<ProcessPointRound>(`${environment.serverUrl}/api/srm-process-point/current-round`);
  }

  public getCurrent(): Observable<SrmPointJobDto> {
    return this.http.get<SrmPointJobDto>(`${environment.serverUrl}/api/srm-process-point/current`);
  }

  public search(param: IgnoreNullHttpParams): Observable<Page<SrmPointJobDto>> {
    return this.http.get<Page<SrmPointJobDto>>(`${environment.serverUrl}/api/srm-process-point/search`, {params: param.toHttpParam()});
  }

  public callJob() {
    return this.http.post(`${environment.serverUrl}/api/srm-process-point/call-job`, {});
  }

  public approve() {
    return this.http.post(`${environment.serverUrl}/api/srm-process-point/approve`, {});
  }

  public regenerateFile() {
    return this.http.post(`${environment.serverUrl}/api/srm-process-point/regenerate-file`, {});
  }

  public moveResultToHis() {
    return this.http.post(`${environment.serverUrl}/api/srm-process-point/move-result-to-his`, {});
  }

  public sentEmailPoint(pointEmailRequestParams: PointEmailRequest) {
    return this.http.post(`${environment.serverUrl}/api/srm-process-point/email-point`, pointEmailRequestParams)
  }
}
